<template>
  <div class="template-items-modal">
    <base-modal-ex :active.sync="active"
      :animation-in="animationIn"
      :animation-out="animationOut"
      :animation-duration="animationDuration"
      :can-cancel="false"
      has-modal-card>
      <div class="model-content">

        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Create a New Template
            </p>
          </header>

          <section class="modal-card-body">

            <div v-if="isLoading || isSaving"
              class="spinner-container">
              <spinner :message=" isLoading ? 'Loading..' : 'Saving...'" />
            </div>

            <div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label is-required-label">Template Name</label>
                    <div class="control">
                      <input class="input"
                        :class="{'is-danger': !templateName || templateName == '' || !isTemplateNameValid}"
                        type="text"
                        placeholder="Enter Quote Template name"
                        v-model="templateName"
                        maxlength="30">
                      <div class="help is-secondary">
                        {{ templateName.length }}/30
                      </div>
                      <div class="tags"
                        v-if="!isTemplateNameValid">
                        <span class="tag is-danger">
                          Name already in use, choose a different name
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-one-third">
                  <div class="field">
                    <label class="label">Add Tag</label>
                    <div class="control"
                      style="position:relative;">
                      <!-- <span class="has-badge-rounded has-badge-medium has-badge-danger"
                        :data-badge="'NEW'" /> -->
                      <div class="dropdown"
                        :class="{ 'is-active': tagDropdownActive }"
                        style="width:100%;">
                        <div class="dropdown-trigger"
                          style="width:100%;">
                          <div class="input tag-input-fake"
                            @click="toggleDropdown">
                            <template v-if="selectedTags.length">
                              <span v-for="tag in selectedTags"
                                :key="tag.tagID"
                                class="tag-short mr-1"
                                :style="{ backgroundColor: tag.colorHex, color: getTextColor(tag.colorHex), marginBottom: '2px' }">
                                {{ tag.shortTag }}
                              </span>
                            </template>
                            <span v-if="!selectedTags.length"
                              style="color:#b5b5b5;">Add tags</span>
                            <span class="icon is-right"
                              style="pointer-events:none;position:absolute;right:10px;top:10px;">
                              <i class="mdi mdi-menu-down" />
                            </span>
                          </div>
                        </div>
                        <TagsDropdownMenu :tags="tags"
                          :selected-tags="selectedTagIDs"
                          :is-visible="tagDropdownActive"
                          @toggle-tag="toggleTag"
                          @clear-all-tags="clearAllTags" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="info-bar mb-4 p-4">
                <div class="columns is-mobile">
                  <div class="column is-half">
                    <div class="info-section">
                      <div class="has-text-weight-bold">Quote Labour Times</div>
                      <div class="mt-2 has-text-weight-bold has-text-primary">{{ quote.labourType }}</div>
                    </div>
                  </div>
                  <div class="column is-half">
                    <div class="info-section">
                      <div class="has-text-weight-bold">Vehicle Body Style</div>
                      <div class="mt-2 has-text-weight-bold has-text-primary">{{ bodyTypeValue?.name || 'N/A' }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="category-item-grid mb-5 mt-5 pb-2">

                <!-- select All -->
                <div class=" is-flex is-justify-content-start">
                  <div class="">
                    <div class="pretty p-icon p-curve p-smooth p-bigger">
                      <input type="checkbox"
                        @click="selectAll(!areAllSelected)"
                        :checked="areAllSelected"
                        :id="'quote-template-items-checkbox-all-items'"
                        :name="'quote-template-items-checkbox-all-items'">
                      <div class="state p-primary">
                        <i class="icon mdi mdi-check" />
                        <label />
                      </div>
                    </div>
                  </div>
                  <div class="is-flex is-justify-content-end">
                    <span class="mr-2">
                      Select All
                    </span>
                  </div>
                </div>

                <div />

              </div>

              <div>
                <div v-for="(type, index) in dataTypes"
                  :key="type.key + index"
                  class="category-item-grid mb-2 pb-2">

                  <div class="is-flex is-justify-content-start">
                    <div>
                      <div class="pretty p-icon p-curve p-smooth p-bigger">
                        <input type="checkbox"
                          :disabled="itemLengths[type.key] == 0"
                          :checked="isSelected(type)"
                          @click="selectItems(type)"
                          :id="'quote-template-items-checkbox-all-items'"
                          :name="'quote-template-items-checkbox-all-items'">
                        <div class="state p-primary">
                          <i class="icon mdi mdi-check" />
                          <label />
                        </div>
                      </div>
                    </div>
                    <span class="mr-2">
                      {{ type.title }}
                    </span>
                  </div>

                  <div class="is-flex is-justify-content-end">
                    <div class="mr-2 has-text-weight-bold has-text-grey-dark">{{ itemLengths[type.key] }}</div>
                  </div>

                </div>
              </div>

            </div>
          </section>

          <footer class="modal-card-foot"
            :style="`justify-content: flex-end`">
            <button class="button"
              @click="close">

              <span class="material-symbols-outlined mr-1">
                close
              </span>
              <span>
                Cancel
              </span>
            </button>
            <button class="button is-success"
              @click="createNewTemplate"
              :disabled="isDisabled">
              <span class="material-symbols-outlined mr-2">
                save
              </span>
              <span>Save</span>
            </button>
          </footer>

        </div>
      </div>
    </base-modal-ex>
  </div>
</template>

<script>
import BaseModalEx from '@/components/BulmaModal/BaseModalEx'
import Spinner from '../../../../components/Spinners/Spinner.vue'
import { QuoteTemplateModel } from '@/classes/viewmodels'
import { QuoteTemplateItemModel } from '../../../../classes/viewmodels'
import QuoteTemplateService from '../../../../services/QuoteTemplateService'
import Guid from '../../../../components/Guid'

import { ItemCategoryTypes } from '@/enums'
import { debounce } from 'lodash'
import { EventHubTypes } from '../../../../enums'
import { VehicleBodyTypes } from '@/enums'
import { getTextColor } from '@/utils/ColorFunctions'
import TagsDropdownMenu from '../../../manageTag/TagsDropdownMenu.vue'
export default {
  name: 'SaveTemplateModal',
  components: {
    BaseModalEx,
    Spinner,
    TagsDropdownMenu
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    dataTypes: {
      type: Array,
      default: () => []
    },
    quote: {
      type: Object,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },
    animationIn: {
      type: String,
      default: 'fadeIn'
    },
    animationOut: {
      type: String,
      default: 'fadeOut'
    },
    animationDuration: {
      type: Number,
      default: 0.3
    },
    label: {
      type: String,
      default: 'Select Template'
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      templateItems: [],
      isActive: this.active || false,

      templateName: '',
      selectedItems: [],

      isTemplateNameValid: true,
      tagDropdownActive: false,
      tagSearch: '',
      selectedTagIDs: []
    }
  },
  computed: {
    areAllSelected() {
      const categoriesWithItems = this.dataTypes.filter((type) => this.itemLengths[type.key] > 0)
      return (
        this.selectedItems.length === categoriesWithItems.length &&
        categoriesWithItems.length > 0 &&
        categoriesWithItems.every((type) => this.selectedItems.includes(type.key))
      )
    },
    isDisabled() {
      return !this.selectedItems.length || this.isLoading || this.isSaving || !this.templateName || this.templateName == '' || !this.isTemplateNameValid
    },
    rrItems() {
      return this.quote.labours.filter((i) => i.itemType === ItemCategoryTypes.RR && !i.isDeleted)
    },
    repItems() {
      return this.quote.labours.filter((i) => i.itemType === ItemCategoryTypes.REP && !i.isDeleted)
    },
    paintItems() {
      return this.quote.labours.filter((i) => i.itemType === ItemCategoryTypes.PAINT && !i.isDeleted)
    },
    partItems() {
      return this.quote.parts.filter((p) => !p.isDeleted)
    },
    mechItems() {
      return this.quote.others.filter((i) => !i.isDeleted && i.itemType == ItemCategoryTypes.MECH)
    },
    subletItems() {
      return this.quote.sublets.filter((i) => !i.isDeleted)
    },
    miscItems() {
      return this.quote.miscs.filter((i) => !i.isDeleted)
    },
    itemLengths() {
      return {
        rr: this.rrItems.length,
        rep: this.repItems.length,
        paint: this.paintItems.length,
        part: this.partItems.length,
        mech: this.mechItems.length,
        sublet: this.subletItems.length,
        misc: this.miscItems.length
      }
    },
    VehicleBodyTypes() {
      return VehicleBodyTypes
    },
    bodyTypeValue() {
      return Object.values(VehicleBodyTypes).find((type) => type.id == this.vehicle?.bodyId) || 'N/A'
    },
    filteredTags() {
      if (!this.tagSearch) return this.tags
      return this.tags.filter(
        (tag) => tag.shortTag.toLowerCase().includes(this.tagSearch.toLowerCase()) || tag.tagName.toLowerCase().includes(this.tagSearch.toLowerCase())
      )
    },
    selectedTags() {
      return this.tags.filter((tag) => this.selectedTagIDs.includes(tag.tagID))
    }
  },
  watch: {
    templateName: {
      handler: debounce(function (val) {
        if (val !== '' && val !== null) {
          this.getTemplateValidity()
        }
      }, 500),
      immediate: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    async getTemplateValidity() {
      const templateNameExists = await QuoteTemplateService.CheckTemplateNameValidity(this.templateName, this.$company.info.companyId)
      this.isTemplateNameValid = !templateNameExists
    },
    close() {
      this.isActive = false
      this.selectedTagIDs = []
      this.$emit('update:active', false)
    },
    isSelected(type) {
      return this.selectedItems.includes(type.key)
    },
    selectItems(type) {
      // if type.key is in selectedItems, remove it
      // else add it
      if (this.selectedItems.includes(type.key)) {
        this.selectedItems = this.selectedItems.filter((item) => item !== type.key)
      } else {
        this.selectedItems.push(type.key)
      }
    },
    selectAll(value) {
      // Check if all item types are empty
      const hasItems = Object.values(this.itemLengths).some((length) => length > 0)
      if (!hasItems) {
        this.$notification.error('Error', 'No items available to create a template')
        return
      }

      if (value) {
        this.selectedItems = this.dataTypes.filter((type) => this.itemLengths[type.key] > 0).map((type) => type.key)
      } else {
        this.selectedItems = []
      }
    },
    async createNewTemplate() {
      this.isSaving = true

      const templateObj = new QuoteTemplateModel()

      templateObj.templateId = Guid.empty()
      templateObj.bodyId = this.vehicle.bodyId
      templateObj.modelId = this.vehicle.model.id
      templateObj.name = this.templateName
      templateObj.companyId = this.$company.info.companyId

      templateObj.quoteType = this.quote.quoteType
      templateObj.timesType = this.quote.labourType
      templateObj.tags = this.selectedTags

      const quoteItems = this.dataTypes.reduce((acc, type) => {
        if (this.selectedItems.includes(type.key)) {
          if (type.key === 'rr') {
            acc.push(...this.rrItems)
          } else if (type.key === 'rep') {
            acc.push(...this.repItems)
          } else if (type.key === 'paint') {
            acc.push(...this.paintItems)
          } else if (type.key === 'part') {
            acc.push(...this.partItems)
          } else if (type.key === 'mech') {
            acc.push(...this.mechItems)
          } else if (type.key === 'sublet') {
            acc.push(...this.subletItems)
          } else if (type.key === 'misc') {
            acc.push(...this.miscItems)
          }
        }
        return acc
      }, [])

      const templateItems = quoteItems.map((item) => {
        const quoteItem = new QuoteTemplateItemModel(item)
        // should this not be in the model ?
        quoteItem.tempateId = Guid.empty()
        quoteItem.itemId = Guid.empty()
        quoteItem.templateItemId = item.quoteItemId
        quoteItem.value = item.hourValue
        return quoteItem
      })

      await QuoteTemplateService.createNewTemplateWithItems(templateObj, templateItems)

      this.isSaving = false

      this.templateName = ''
      this.selectedItems = []
      // show toadt
      this.$notification.success('Template', 'New Template Created')
      this.close()
      this.$eventHub.$emit(EventHubTypes.ReloadQuoteTemplate)
    },
    toggleTag(tag) {
      const idx = this.selectedTagIDs.indexOf(tag.tagID)
      if (idx === -1) {
        this.selectedTagIDs.push(tag.tagID)
      } else {
        this.selectedTagIDs.splice(idx, 1)
      }
    },
    getTextColor,
    toggleDropdown() {
      this.tagDropdownActive = !this.tagDropdownActive
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.dropdown')
      if (dropdown && !dropdown.contains(event.target)) {
        this.tagDropdownActive = false
      }
    },
    clearAllTags() {
      this.selectedTagIDs = []
    }
  }
}
</script>

<!-- <style scoped>
.tag-input-fake {
  min-height: 2.25em;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 2px 40px 2px 8px;
  transition: border-color .2s;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  position: relative;
  max-height: 300px;      /* increase max-height if you want */
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;       /* <-- add this line */
}
.tag-input-fake::-webkit-scrollbar {
  height: 6px;
}
.tag-input-fake::-webkit-scrollbar-thumb {
  background: #dbdbdb;
  border-radius: 3px;
}
</style> -->

<style  scoped lang="scss">
@use '@/assets/style/override-colours' as oc;

.template-items-modal,
.modal-card {
  min-width: 800px;
  width: 60vw;
}

.template-items-container {
  overflow-y: auto;
  max-height: 50vh;
}

.category-item-grid {
  display: grid;
  grid-template-columns: 90% 10%;
  // grid-gap: 1rem;
  border-bottom: 2px solid #cfcbcb;

  // .item-count {
  //   background: $primary;
  //   border-radius: 50%;
  //   width: 25px;
  //   height: 25px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   color: white;
  // }
}

.info-bar {
  // background-color: lighten(oc.$primary, 35%);
  background-color: var(--bulma-primary-75);
  border-radius: 5px;
  border-left: 6px solid oc.$primary;
}
</style>